<template>
  <div class="bg-container page">
    <div class="dong_box">
      <div class="dong_i"></div>
    </div>
    <div class="bg-wrapper">
      <div class="register">
        <van-nav-bar class="nav-bar">
          <template #left>
            <div style="display: flex; align-items: center" @click="back()">
              <img
                src="/img/newLogin/download.png"
                style="width: 20px; height: 15px"
              />
              <span
                style="font-size: 16px; color: #f3c7a2; margin-left: 10px"
                >{{ $t("q0") }}</span
              >
            </div>
          </template>
        </van-nav-bar>
        <div class="wrapper">
          <div class="title">{{ $t("auth.register") }}</div>
          <div class="loginForm">
            <van-field
              v-model="username"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.username_place1')"
            />
            <div class="sm_tit">
              {{ $t("q2") }}
            </div>
            <van-field
              v-model="password"
              :type="passwordType"
              input-align="center"
              class="input"
              :placeholder="$t('auth.pwd_place1')"
            >
              <template slot="right-icon">
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>
            <div class="sm_tit">
              {{ $t("q3") }}
            </div>
            <!-- <div class="yam_box">
              <van-field
                v-model="yzm"
                input-align="center"
                class="input"
                :placeholder="$t('auth.yzm_place')"
              >
              </van-field>
              <div class="ym_x">
                <Captcha ref="Captcha" />
              </div>
            </div> -->

            <!-- <div class="sm_tit">{{ $t("auth.invite_code_place") }}</div> -->

            <van-field
              v-model="code"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.invite_code_place')"
            />
            <!-- <div class="agreement">
              <van-checkbox v-model="checked" />
              <span class="agreement-text">{{$t("auth.agreement_place")}}</span>
            </div> -->

            <div class="sm_tit">
              {{ $t("q4") }}
            </div>
            <div class="agreement">
              <van-checkbox v-model="checked" />
              <span class="agreement-text">{{
                $t("auth.agreement_place1")
              }}</span>
            </div>
            <van-button
              class="login-btn"
              type="primary"
              size="normal"
              @click="doRegister()"
              >{{ $t("auth.register1") }}</van-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Captcha from "./Captcha.vue";
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  components: {},
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // captchaValue: "",
      yzm: "",
      checked: true,
      username: "",
      code: "",
      lang: "en_us",
      password: this.inputValue,
      passwordType: "password",
    };
  },
  mounted() {
    this.lang = localStorage.getItem("lang") || "es_spa";
  },
  methods: {
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    doRegister() {
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined
      ) {
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if (
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }

      // let cc = this.$refs.Captcha.getYam();
      // if (cc.trim().toLowerCase() != this.yzm.trim().toLowerCase()) {
      //   this.$toast.fail("4桁の英数字の認証コードをご入力ください");
      //   return false;
      // }

      // if (this.code === "" || this.code === null || this.code === undefined) {
      //   this.$toast.fail(this.$t("auth.invite_code_place"));
      //   return false;
      // }
      if (!this.checked) {
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }
      this.$http({
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          code: this.code,
          lang: this.lang,
        },
        url: "member_register",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data);
          this.$router.push("Mine");
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.yam_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .ym_x {
    margin-left: 20px;
    padding-top: 40px;
  }
}
.sm_tit {
  font-size: 20px;
  color: #c5c5c5;
  padding-left: 36px;
  margin: 10px 0 20px;
}
.sm_tit_sk {
  font-size: 28px;
  color: #fff;
}
.dong_box {
  height: 100%;
  @keyframes bg-data-v-8175861c {
    0%,
    100% {
      background-position-x: 0;
    }
    50% {
      background-position-x: 100%;
    }
  }
  .dong_i {
    height: 100%;
    height: 100%;
    width: auto;
    animation: bg-data-v-8175861c 20s linear infinite;
    background: url(/img/newLogin/login.jpg) no-repeat 0 0;
    background-size: auto 100%;
    height: 100%;
  }
}
.register {
  height: 100%;
}
.bg-container .bg-wrapper .register .nav-bar {
  background: 0 0;
}
.bg-container .bg-wrapper {
  background: #00000082 no-repeat 0 0;
  background-size: 100% 100%;
}
.register .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container {
  margin: 0 auto;
  width: 45%;
}
.logo-container .logo-wrapper {
  position: relative;
  padding-bottom: 62.5%;
}
.logo-container .logo-wrapper .logo-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}
.register .wrapper .title {
  line-height: 100px;
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 5px;
}
.register .wrapper .loginForm {
  padding: 60px;
}
.register .wrapper .loginForm .input {
  padding: 26px 20px;
  margin-top: 40px;
  border-radius: 10px;
  text-align: center;
  // line-height: 80px;
  font-size: 30px;

  width: 100% !important;
  height: 100%;
  box-sizing: border-box;

  background: linear-gradient(120deg, #212121, #313131);
  border: 2px solid #766350;
  color: #e6b98a;
}
::v-deep .van-cell::after {
  display: none;
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}
::v-deep .van-icon {
  font-size: 50px;
}
::v-deep .van-field__control {
  color: #e6b98a;
}
.register .wrapper .loginForm .reset-text {
  margin: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.register .wrapper .loginForm .reset-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 15px;
}
.register .wrapper .loginForm .register-text {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.register .wrapper .loginForm .register-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 20px;
}
.register .wrapper .loginForm .login-btn {
  margin-top: 85px;
  width: 100%;
  height: 80px;
  border-radius: 50px;
  color: #68302c;
  background: linear-gradient(#fde3ca, #e7b486);
  font-size: 30px;
  font-weight: bolder;
  border: none;
}
.register .wrapper .loginForm .agreement {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.register .wrapper .loginForm .agreement .agreement-text {
  margin-left: 10px;
  font-size: 25px;
  color: #fff;
  font-weight: 500;
  line-height: 30px;
}
::v-deep .agreement .van-icon {
  font-size: 30px;
}
::v-deep .agreement .van-checkbox__icon {
  font-size: 38px;
}
::v-deep .agreement .van-checkbox__icon--checked .van-icon {
  color: #fff;
  border-color: rgb(126, 86, 120);
  background-color: rgb(126, 86, 120);
}

@media screen and (min-width: 1024px) {
  .nav-bar {
    height: 50px;
  }
  .sm_tit {
    font-size: 16px;
    padding: 0;
    margin: 5px 0;
    text-align: center;
  }

  .register .wrapper .loginForm .agreement {
    padding: 5px;
    margin-top: 20px;
  }

  ::v-deep .agreement .van-icon {
    font-size: 20px;
    margin: 14px;
  }

  .register .wrapper .title {
    font-size: 25px;
    line-height: 150px;
  }

  .register .wrapper .loginForm {
    padding: 10px;
  }
  .van-nav-bar__content {
    height: 100px;
  }

  .van-nav-bar .van-icon {
    font-size: 16px;
  }

  .van-nav-bar__title {
    font-size: 16px;
    max-width: 80%;
    margin: 0 auto;
    color: #f3c7a2;
  }

  .language img {
    height: 70%;
  }

  .register .wrapper .loginForm .input {
    font-size: 16px;
    padding: 5px 1px;
    margin-top: 30px;
  }

  .register .wrapper .loginForm .login-btn {
    width: 100%;
    height: 50px;
    font-size: 16px;
    margin-top: 20px;
  }

  .van-field__right-icon .van-icon {
    font-size: 20px;
  }

  .c_bott,
  .register .wrapper .loginForm .agreement .agreement-text {
    font-size: 16px;
    line-height: 20px;
  }

  .dong_i {
    background-size: auto 100%;
  }

  .van-empty__image {
    width: 300px;
    height: 300px;
  }
  .van-empty__description {
    font-size: 16px;
  }

  ::v-deep .agreement .van-checkbox__icon--checked .van-icon {
    margin: 14px;
  }

  ::v-deep .van-field__clear {
    font-size: 20px;
    width: 20px;
    height: 20px;
    transform: translateY(0);
  }
}
</style>
